export const StoreModule = {
  namespaced: true,
  state: () => {
    return {}
  },
  mutations: {},
  actions: {}
}
